import {
  FaLaptopCode, FaPalette, FaMobileAlt, FaNetworkWired, FaServer,
  FaVideo, FaSchool, FaCalendarAlt, FaCloud,
  FaComments, FaClipboardList, FaPencilRuler, FaCode, FaFlask, FaRocket, FaTools
} from 'react-icons/fa';

// Services data
export const services = [
  {
    id: 1,
    title: 'Website Development',
    description: 'Custom website development using modern technologies to create responsive, user-friendly, and high-performing websites.',
    icon: FaLaptopCode
  },
  {
    id: 2,
    title: 'Web Design',
    description: 'Creative and intuitive web designs that enhance user experience and effectively communicate your brand message.',
    icon: FaPalette
  },
  {
    id: 3,
    title: 'Mobile Application Development',
    description: 'Development of native and cross-platform mobile applications for iOS and Android devices.',
    icon: FaMobileAlt
  },
  {
    id: 4,
    title: 'Computer Network Designing',
    description: 'Design and implementation of secure and efficient computer networks for businesses of all sizes.',
    icon: FaNetworkWired
  },
  {
    id: 5,
    title: 'Server Installation',
    description: 'Professional server installation and configuration services to ensure optimal performance and security.',
    icon: FaServer
  },
  {
    id: 6,
    title: 'Surveillance Cameras',
    description: 'Installation and maintenance of surveillance camera systems for enhanced security and monitoring.',
    icon: FaVideo
  },
  {
    id: 7,
    title: 'School Management System',
    description: 'Comprehensive school management systems (SIS, SMS, LMS) to streamline educational administration and enhance learning.',
    icon: FaSchool
  },
  {
    id: 8,
    title: 'CRM - Organise Events and More',
    description: 'Customer Relationship Management solutions to help businesses organize events, manage contacts, and improve customer relations.',
    icon: FaCalendarAlt
  },
  {
    id: 9,
    title: 'Server and Website Hosting',
    description: 'Reliable server and website hosting services with excellent uptime, security, and technical support.',
    icon: FaCloud
  }
];

// Portfolio projects
export const projects = [
  {
    id: 1,
    title: 'LSST',
    category: 'education',
    bgColor: '#2c3e50',
    url: 'https://lsst.ac',
    description: 'School Management System'
  },
  {
    id: 2,
    title: 'FSB',
    category: 'education',
    bgColor: '#3498db',
    url: 'https://fairfield.ac',
    description: 'School Management System'
  },
  {
    id: 3,
    title: 'Everlasting Brows',
    category: 'ecommerce',
    bgColor: '#e74c3c',
    url: 'https://everlastingbrows.com',
    description: 'E-commerce Website'
  },
  {
    id: 4,
    title: 'Sleekbrows',
    category: 'ecommerce',
    bgColor: '#9b59b6',
    url: 'https://sleekbrows.com',
    description: 'E-commerce Website'
  },
  {
    id: 5,
    title: 'Signet Contemporary Art',
    category: 'business',
    bgColor: '#f39c12',
    url: 'https://signetcontemporaryart.com',
    description: 'Art Gallery Website'
  },
  {
    id: 6,
    title: 'EladoreRuffles',
    category: 'ecommerce',
    bgColor: '#16a085',
    url: 'https://eladoreruffles.com',
    description: 'E-commerce Website'
  },
  {
    id: 7,
    title: 'FullCourt',
    category: 'business',
    bgColor: '#e67e22',
    url: 'https://fullcourt.eu/en',
    description: 'Business Platform'
  }
];

// Testimonials data
export const testimonials = [
  {
    id: 1,
    content: "LSST and its associates companies has received remarkable services and support from GDWD. GDWD managed to build and replace our old database software to new database system which has improved much further and better facilities compare to all other software systems. I tried many other companies and softwares but I found that designed software by GDWD is excellent. We always find GDWD available when ever we need support.",
    client: "LSST",
    position: "London School of Science & Technology",
    rating: 5
  },
  {
    id: 2,
    content: "The team at GDWD delivered exceptional e-commerce solutions for our business. Their attention to detail and commitment to quality is outstanding.",
    client: "Everlasting Brows",
    position: "E-commerce Platform",
    rating: 5
  },
  {
    id: 3,
    content: "Professional, efficient, and highly skilled. GDWD transformed our digital presence completely.",
    client: "Signet Contemporary Art",
    position: "Art Gallery",
    rating: 5
  }
];

// Process timeline steps
export const processSteps = [
  {
    id: 1,
    title: 'Consultation',
    description: 'We begin by understanding your requirements, goals, and challenges through detailed discussions and requirement gathering sessions.',
    icon: FaComments
  },
  {
    id: 2,
    title: 'Planning',
    description: 'Based on the consultation, we develop a comprehensive plan outlining the scope, timeline, deliverables, and resources required for your project.',
    icon: FaClipboardList
  },
  {
    id: 3,
    title: 'Design',
    description: 'Our designers create wireframes and prototypes to visualize the solution and get your feedback before moving to the development phase.',
    icon: FaPencilRuler
  },
  {
    id: 4,
    title: 'Development',
    description: 'Our development team brings the design to life using the latest technologies and best practices to ensure high-quality, efficient, and secure solutions.',
    icon: FaCode
  },
  {
    id: 5,
    title: 'Testing',
    description: 'We conduct thorough testing to identify and fix any issues, ensuring the solution meets all requirements and quality standards.',
    icon: FaFlask
  },
  {
    id: 6,
    title: 'Deployment',
    description: 'Once testing is complete, we deploy the solution to your production environment, ensuring a smooth transition and minimal disruption.',
    icon: FaRocket
  },
  {
    id: 7,
    title: 'Support & Maintenance',
    description: 'We provide ongoing support and maintenance to ensure your solution continues to perform optimally and remains up-to-date.',
    icon: FaTools
  }
];

// Stats data
export const stats = [
  { label: 'Happy Clients', value: '100+' },
  { label: 'Projects Completed', value: '200+' },
  { label: 'Years Experience', value: '10+' },
  { label: 'Support', value: '24/7' }
];
